import React, { useState } from 'react';
import {
  TextField,
  Typography,
  Button
} from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';
import PopupBase from '../../../../popup/base/PopupBase';

const AnnulRecordDialog = ({ open, onClose, onConfirm, isSubmitting }) => {
  const [annulReason, setAnnulReason] = useState('');

  const handleClose = () => {
    setAnnulReason('');
    onClose();
  };

  const handleConfirm = () => {
    onConfirm(annulReason);
  };

  if (!open) return null;

  const dialogContent = (
    <>
      <Typography variant="body1" sx={{ marginBottom: '16px' }}>
        Você está prestes a anular um registro de evolução. Esta ação não pode ser desfeita.
        Por favor, forneça um motivo para a anulação:
      </Typography>
      <TextField
        autoFocus
        margin="dense"
        id="annulReason"
        label="Motivo da anulação"
        type="text"
        fullWidth
        multiline
        rows={3}
        variant="outlined"
        value={annulReason}
        onChange={(e) => setAnnulReason(e.target.value)}
      />
    </>
  );

  const negativeButton = (
    <Button
      onClick={handleClose}
      variant="outlined"
      sx={{ color: ColorPalette.textMedium }}
    >
      Cancelar
    </Button>
  );

  const positiveButton = (
    <Button
      onClick={handleConfirm}
      variant="contained"
      disabled={!annulReason.trim() || isSubmitting}
      sx={{
        backgroundColor: ColorPalette.secondary,
        '&:hover': {
          backgroundColor: ColorPalette.secondary
        }
      }}
    >
      Anular Registro
    </Button>
  );

  return (
    <PopupBase
      Title="Anular Registro de Evolução"
      Content={dialogContent}
      NegativeButton={negativeButton}
      PositiveButton={positiveButton}
      OnClose={handleClose}
      maxWidth="sm"
    />
  );
};

export default AnnulRecordDialog;